import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIdPath = returnPath("/admin/persons/:id");
export const getIndexPath = returnPath("/admin/persons");
